"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupFieldValueGetter = void 0;
const base_calculated_fieldtype_1 = require("../base-calculated.fieldtype");
const number_1 = require("../../type-checking/number");
class RollupFieldValueGetter extends base_calculated_fieldtype_1.BaseCalculatedFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            // Rollup should support number as string if target field is Currency
            return (0, number_1.isDecimal128Value)(fieldValue) || (0, number_1.isNullableNumberValue)(fieldValue);
        };
        this.getEmptyValue = () => null;
    }
}
exports.RollupFieldValueGetter = RollupFieldValueGetter;
